//#region src/assets/vana-pay-logo-white.svg
var vana_pay_logo_white_default = "" + new URL("vana-pay-logo-white-BZF-mLOE.svg", import.meta.url).href;
//#endregion
export { vana_pay_logo_white_default as default };

//# sourceMappingURL=vana-pay-logo-white.js.map